import React, { Component } from 'react'
import { post, get } from '../../../utils/networking'
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";
import MyServices from './myServices'
import MyStore from './myStore'
import CheckInPopup from '../../checkInPopup'
import $ from 'jquery'
import './style.css'

export default class Overview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            referralTree: {},
            activeTab: 1,
            defaultStoreSlug: "",
            isShowCheckInPopup: false,
            profile: {},
            currentStore: null
        }
    }

    componentWillMount() {
        get('user/getMyProfile', "customer", result => {
            this.setState({
                referralTree: result.user
            }, () => {
                get('store/get', "customer", result => {
                    this.setState({
                        defaultStoreSlug: result[0].slug,
                    })
                })
            })
        })
    }
    handleGetProfile(callback) {
        get('user/getMyProfile', "customer", result => {
            this.setState({
                profile: result,
                currentStore: result.stores[0]
            })
        }, () => callback())
    }

    render() {
        let {
            referralTree,
            activeTab,
            defaultStoreSlug,
            isShowCheckInPopup,
            profile,
            currentStore
        } = this.state;
        $("html, body").animate({ scrollTop: 0 }, 400);
        return (
            <div className="overview">
                <CheckInPopup
                    profile={profile}
                    currentStore={currentStore}
                    isShow={isShowCheckInPopup}
                    cancel={() => this.setState({ isShowCheckInPopup: false })}
                    changeCurrentStore={(store) => this.setState({ currentStore: store })} />
                <div className="overview_menu">
                    <span className={(activeTab === 1) ? "my_store_bt active" : "my_store_bt"} onClick={() => this.setState({ activeTab: 1 })}>My Nails Salon</span>
                    <span className="space">|</span>
                    <span className={(activeTab === 2) ? "my_service_bt active" : "my_service_bt"} onClick={() => this.setState({ activeTab: 2 })}>Service History</span>
                    <span className="bt-book-now" onClick={() => {
                        this.props.history.push("/spa/" + defaultStoreSlug + "?tab=3")
                    }}>Book Appointment</span>
                    <span className="bt-book-now" onClick={() => this.handleGetProfile(this.setState({ isShowCheckInPopup: true }))}>Check in Now</span>
                </div>
                <div className="content">
                    {
                        (activeTab === 1) ?
                            <div className="my_store_content">
                                <MyStore history={this.props.history} />
                            </div> :
                            <div className="service_histore_content">
                                <MyServices history={this.props.history} />
                            </div>
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/user/overview/index.js